export const StringService = {
  getPrettyDate(created: number) {
    const date = new Date(created);
    return date.toLocaleString();
  },
};
